import { Popconfirm, message, Tooltip } from "antd";
import React, { Component } from "react";
import axios from "axios";
import {
  ButtonItem,
  SegmentedItem,
  TableItemDinamico,
  SelectEscuelasItem,
} from "../../../../Components/Items";
import { connect } from "react-redux";
import {
  StopOutlined,
  EditOutlined,
  CheckCircleOutlined,
  // UnorderedListOutlined,
  ImportOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import GrupoEscuelaModal from "../GrupoEscuelaModal/GrupoEscuelaModal";
// import ListaEscuelaModal from "../ListaEscuelaModal/ListaEscuelaModal";
import AlumnosGrupoModal from "../AlumnosGrupoModal/AlumnosGrupoModal";
import AlumnoModal from "../AlumnoModal/AlumnoModal";
import ResumenEcommerceModal from "../ResumenEcommerceModal/ResumenEcommerceModal";

class GruposTab extends Component {
  tableRef = null;
  state = {
    todosGrupos: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
    escuelaFiltro: undefined,
    modalGrupoVisible: false,
    grupoSeleccionado: null,
    // modalListaVisible: false,
    // grupoIdParaLista: null,
    modalAlumnosVisible: false,
    grupoIdParaAlumnos: null,
    generandoUsuariosGrupoId: null,
    modalResumenVisible: false,
    resumenGeneracion: null,
    modalAlumnoVisible: false,
    grupoParaAlumno: null,
  };

  consultarGrupos = (params) => {
    this.setState({ loading: true });
    axios
      .post(
        "gruposEscuela/selectTodosGruposEscuela",
        {
          empresaId: this.props.empresaId,
          escuelaId: this.state.escuelaFiltro,
          ...params,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todosGrupos: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todosGrupos: [], totalRecords: 0, loading: false });
        }
      });
  };

  cambiarEscuelaFiltro = (escuelaId) => {
    this.setState({ escuelaFiltro: escuelaId }, () => {
      if (this.tableRef)
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    });
  };

  abrirAgregar = () => {
    this.setState({ modalGrupoVisible: true, grupoSeleccionado: null });
  };
  abrirEditar = (grupo) => {
    this.setState({ modalGrupoVisible: true, grupoSeleccionado: grupo });
  };
  cerrarModalGrupo = (recargar = false) => {
    this.setState({ modalGrupoVisible: false, grupoSeleccionado: null });
    if (recargar && this.tableRef)
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
  };

  // abrirAgregarLista = (grupoId) => {
  //   this.setState({ modalListaVisible: true, grupoIdParaLista: grupoId });
  // };
  // cerrarModalLista = (recargar = false) => {
  //   this.setState({ modalListaVisible: false, grupoIdParaLista: null });
  //   if (recargar && this.tableRef)
  //     this.tableRef.updateExternalFilters({ valor: this.state.valor });
  // };

  abrirVerAlumnos = (grupoId) => {
    this.setState({ modalAlumnosVisible: true, grupoIdParaAlumnos: grupoId });
  };
  cerrarVerAlumnos = () => {
    this.setState({ modalAlumnosVisible: false, grupoIdParaAlumnos: null });
  };

  generarUsuariosEcommerce = (grupoId) => {
    this.setState({ generandoUsuariosGrupoId: grupoId });
    axios
      .post(
        "usuariosEcommerce/crearUsuariosEcommercePorGrupo",
        { grupoEscuelaId: grupoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({
            resumenGeneracion: res.data.data,
            modalResumenVisible: true,
          });
          if (this.tableRef)
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
        } else {
          message.error(res.data.message || "No se pudo generar");
        }
      })
      .catch(() => message.error("Error al comunicar con el servidor"))
      .finally(() => this.setState({ generandoUsuariosGrupoId: null }));
  };

  cerrarModalResumen = () => {
    this.setState({ modalResumenVisible: false, resumenGeneracion: null });
  };

  abrirAgregarAlumno = (grupo) => {
    this.setState({
      modalAlumnoVisible: true,
      grupoParaAlumno: { _id: grupo._id, escuelaId: grupo.escuelaId },
    });
  };

  cerrarAgregarAlumno = (recargar = false) => {
    this.setState({ modalAlumnoVisible: false, grupoParaAlumno: null });
    if (recargar && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  };

  cambiarEstado = (id, deshabilitar) => {
    const url = deshabilitar
      ? "gruposEscuela/deshabilitarGrupoEscuela"
      : "gruposEscuela/habilitarGrupoEscuela";
    axios
      .post(
        url,
        { grupoEscuelaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2)
          message.success(deshabilitar ? "Deshabilitado" : "Habilitado");
        else message.error("Error");
        if (this.tableRef)
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
      });
  };

  render() {
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre", sorter: true, buscar: "nombre" },
      { title: "Escuela", dataIndex: "escuelaNombre", key: "escuelaNombre", ellipsis: true },
      { title: "Nivel", dataIndex: "nivelEducativoNombre", key: "nivelEducativoNombre", ellipsis: true },
      { title: "Grado", dataIndex: "grado", key: "grado", buscar: "grado", width: 100 },
      { title: "Programa", dataIndex: "programaEducativoNombre", key: "programaEducativoNombre", ellipsis: true },
      // { title: "Lista", dataIndex: "listaNombre", key: "listaNombre", ellipsis: true, render: (v) => v || "—" },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "20%",
        onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
        render: (value, record) => (
          <div className="acciones-container">
            <Tooltip title={this.props.permisoEditarGrupo ? "Editar Grupo" : "No disponible"}>
              <ButtonItem
                size="small"
                cyan
                icon={<EditOutlined />}
                disabled={!this.props.permisoEditarGrupo}
                onClick={() => this.props.permisoEditarGrupo && this.abrirEditar(record)}
              />
            </Tooltip>
            {/*
            <Tooltip title="Agregar / Editar Lista para este grupo">
              <ButtonItem
                size="small"
                azul
                icon={<UnorderedListOutlined />}
                onClick={() => this.abrirAgregarLista(value._id)}
              />
            </Tooltip>
            */}
            <Tooltip title={this.props.permisoAgregarAlumnoGrupo ? "Agregar alumno a este grupo" : "No disponible"}>
              <ButtonItem
                size="small"
                olivo
                icon={<UserAddOutlined />}
                disabled={!this.props.permisoAgregarAlumnoGrupo}
                onClick={() => this.props.permisoAgregarAlumnoGrupo && this.abrirAgregarAlumno(record)}
              />
            </Tooltip>
            <Tooltip title={this.props.permisoVerImprimirGrupo ? "Ver / Imprimir alumnos del grupo" : "No disponible"}>
              <ButtonItem
                size="small"
                morado
                icon={<TeamOutlined />}
                disabled={!this.props.permisoVerImprimirGrupo}
                onClick={() => this.props.permisoVerImprimirGrupo && this.abrirVerAlumnos(value._id)}
              />
            </Tooltip>
            <Popconfirm
              title="¿Generar usuarios de ecommerce para todos los alumnos activos de este grupo? Se usará la matrícula como correo y contraseña."
              okText="Generar"
              cancelText="Cancelar"
              onConfirm={() => this.generarUsuariosEcommerce(value._id)}
              disabled={!this.props.permisoGenerarUsuariosEcommerce}
            >
              <Tooltip title={this.props.permisoGenerarUsuariosEcommerce ? "Generar usuarios ecommerce para todos los alumnos" : "No disponible"}>
                <ButtonItem
                  size="small"
                  naranja
                  icon={<UsergroupAddOutlined />}
                  disabled={!this.props.permisoGenerarUsuariosEcommerce}
                  loading={this.state.generandoUsuariosGrupoId === value._id}
                />
              </Tooltip>
            </Popconfirm>
            {value.estado === 1 ? (
              <Popconfirm
                title="¿Deshabilitar este grupo?"
                onConfirm={() => this.cambiarEstado(value._id, true)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarGrupo}
              >
                <Tooltip title={this.props.permisoDeshabilitarGrupo ? "Deshabilitar" : "No disponible"}>
                  <ButtonItem size="small" lima icon={<CheckCircleOutlined />} disabled={!this.props.permisoDeshabilitarGrupo} />
                </Tooltip>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="¿Habilitar este grupo?"
                onConfirm={() => this.cambiarEstado(value._id, false)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarGrupo}
              >
                <Tooltip title={this.props.permisoDeshabilitarGrupo ? "Habilitar" : "No disponible"}>
                  <ButtonItem size="small" rojo icon={<StopOutlined />} disabled={!this.props.permisoDeshabilitarGrupo} />
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
            flexWrap: "wrap",
          }}
        >
          <div style={{ minWidth: 250, flex: 1 }}>
            <SelectEscuelasItem
              placeholder="Filtrar por escuela"
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              value={this.state.escuelaFiltro}
              onChange={this.cambiarEscuelaFiltro}
              allowClear
            />
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <SegmentedItem
              options={[
                { label: "Activo", value: 1 },
                { label: "Deshabilitado", value: 2 },
                { label: "Todos", value: 3 },
              ]}
              onChange={(value) => {
                if (this.tableRef)
                  this.tableRef.updateExternalFilters({ valor: value });
                this.setState({ valor: value });
              }}
              value={this.state.valor}
            />
            {this.props.permisoImportarGrupos && (
              <ButtonItem
                type="default"
                className="botonAgregar"
                icon={<ImportOutlined />}
                onClick={() => this.props.history.push("/panel/importarGrupos")}
              >
                Importar Grupos
              </ButtonItem>
            )}
            {this.props.permisoAgregarGrupo && (
              <ButtonItem
                type="primary"
                olivo
                className="botonAgregar"
                onClick={this.abrirAgregar}
              >
                Agregar Grupo
              </ButtonItem>
            )}
          </div>
        </div>

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarGrupos}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todosGrupos}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () =>
              this.props.permisoEditarGrupo && this.abrirEditar(record),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          filterStorageKey={"gruposEscuelaFiltrosTabla" + this.props.empresaId}
        />

        <GrupoEscuelaModal
          visible={this.state.modalGrupoVisible}
          grupo={this.state.grupoSeleccionado}
          cerrarModal={this.cerrarModalGrupo}
        />
        {/* 
        <ListaEscuelaModal
          visible={this.state.modalListaVisible}
          grupoEscuelaId={this.state.grupoIdParaLista}
          cerrarModal={this.cerrarModalLista}
        />
        */}
        <AlumnosGrupoModal
          visible={this.state.modalAlumnosVisible}
          grupoEscuelaId={this.state.grupoIdParaAlumnos}
          cerrarModal={this.cerrarVerAlumnos}
        />

        <AlumnoModal
          visible={this.state.modalAlumnoVisible}
          escuelaIdInicial={this.state.grupoParaAlumno?.escuelaId}
          grupoEscuelaIdInicial={this.state.grupoParaAlumno?._id}
          cerrarModal={this.cerrarAgregarAlumno}
        />

        <ResumenEcommerceModal
          visible={this.state.modalResumenVisible}
          resumen={this.state.resumenGeneracion}
          cerrarModal={this.cerrarModalResumen}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoImportarGrupos:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3b02895863914405746d"
    )?.activado,
  permisoAgregarGrupo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3b1c8958639144057471"
    )?.activado,
  permisoEditarGrupo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3b6d8958639144057481"
    )?.activado,
  permisoAgregarAlumnoGrupo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3b94895863914405748b"
    )?.activado,
  permisoVerImprimirGrupo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3bb98958639144057498"
    )?.activado,
  permisoGenerarUsuariosEcommerce:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3be3895863914405749e"
    )?.activado,
  permisoDeshabilitarGrupo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3c0489586391440574a2"
    )?.activado,
});

export default connect(mapStateToProps)(GruposTab);
